import * as React from 'react';

import LazyComponent from 'libs/LazyComponent';

import type { BarGraphProps as Props } from 'types';

const onLazyImport = () => import(/* webpackChunkName: "plugin.echarts" */ './BarGraph');

const BarGraphLazy = (props: Props): JSX.Element => <LazyComponent
  {...props}
  onLazyImport={onLazyImport}
/>;

export default BarGraphLazy;
